import {
  GenericDateIsoStringInputComponent,
  GenericDisabledTextInputComponent,
  GenericFreeTextInputComponent,
  GstNumberInputComponent,
} from "./InputComponents";

export const vendorDefinition = {
  id: {
    displayName: "ID",
    displayValue: (vendor) => String(vendor.id),
    inputComponent: GenericFreeTextInputComponent,
    isValid: (vendor) => String(vendor.id) !== "",
  },

  tradingName: {
    displayName: "Name",
    displayValue: (vendor) => String(vendor.tradingName),
    inputComponent: GenericFreeTextInputComponent,
    isValid: (vendor) => vendor.tradingName !== "",
  },

  gstNo: {
    displayName: "GST No.",
    displayValue: (vendor) => String(vendor.gstNo),
    inputComponent: GstNumberInputComponent,
    isValid: (vendor) => /\d{3}-\d{3}-\d{3}/.test(vendor.gstNo),
  },

  contactName: {
    displayName: "Contact Name",
    displayValue: (vendor) => String(vendor.contactName),
    inputComponent: GenericFreeTextInputComponent,
    isValid: (vendor) => vendor.contactName !== "",
  },

  phone: {
    displayName: "Phone No.",
    displayValue: (vendor) => String(vendor.phone),
    inputComponent: GenericFreeTextInputComponent,
    isValid: (vendor) => /\d*/.test(vendor.phone),
  },

  mobile: {
    displayName: "Mobile No.",
    displayValue: (vendor) => String(vendor.mobile),
    inputComponent: GenericFreeTextInputComponent,
    isValid: (vendor) => /\d*/.test(vendor.mobile),
  },

  street: {
    displayName: "Street",
    displayValue: (vendor) => String(vendor.street),
    inputComponent: GenericFreeTextInputComponent,
    isValid: (vendor) => vendor.street !== "",
  },

  suburb: {
    displayName: "Suburb",
    displayValue: (vendor) => String(vendor.suburb),
    inputComponent: GenericFreeTextInputComponent,
    isValid: (vendor) => vendor.suburb !== "",
  },

  city: {
    displayName: "City",
    displayValue: (vendor) => String(vendor.city),
    inputComponent: GenericFreeTextInputComponent,
    isValid: (vendor) => vendor.city !== "",
  },

  postCode: {
    displayName: "Post Code",
    displayValue: (vendor) => String(vendor.postCode),
    inputComponent: GenericFreeTextInputComponent,
    isValid: (vendor) => /\d{4}/.test(vendor.postCode),
  },

  startDate: {
    displayName: "Start Date",
    displayValue: (entity) =>
      entity.startDate ? entity.startDate.split("T")[0] : "",
    inputComponent: GenericDateIsoStringInputComponent,
    isValid: (entity) => {
      if (entity.startDate && entity.endDate) {
        return entity.startDate <= entity.endDate;
      } else {
        return true;
      }
    },
  },

  endDate: {
    displayName: "End Date",
    displayValue: (entity) =>
      entity.endDate ? entity.endDate.split("T")[0] : "",
    inputComponent: GenericDateIsoStringInputComponent,
    isValid: (entity) => {
      if (entity.startDate && entity.endDate) {
        return entity.startDate <= entity.endDate;
      } else {
        return true;
      }
    },
  },
};

export const columns = [
  "id",
  "tradingName",
  "gstNo",
  "contactName",
  "phone",
  "mobile",
  "street",
  "suburb",
  "city",
  "postCode",
  "startDate",
  "endDate",
];

export const defaultVendor = {
  id: "",
  tradingName: "",
  gstNo: "",
  contactName: "",
  phone: "",
  mobile: "",
  street: "",
  suburb: "",
  city: "",
  postCode: "",
  startDate: undefined,
  endDate: undefined,
};
